import React, { 
	useRef, 
	useEffect, useState,
	//useState 
} from "react";
import { connect } from "react-redux";

import { CalciteBlock, CalciteButton, 
	//CalciteInput, CalciteNotice,
	CalcitePanel,
CalciteSelect,
CalciteOption,
CalciteStepper,
CalciteStepperItem,
CalciteLabel
} from "@esri/calcite-components-react";
import {loadGraphingSelectOptions,} from '../../../../../Flux/thunks';
import {DownloadDataIntoCsv} from '../../../../../Logic/DataLogic';
//import * as watchUtils from "@arcgis/core/core/watchUtils";
//import {GenerateUrlOptions, CreateUrlFromUrlOptions} from '../../Logic/UrlOptionsLogic';

const DownloadDataBlock = ({graphingOptions, initGraphOptions}) => {
	const iframeRef = useRef(null);
	const [dataOptions, SetDataOptions] = useState({
		state: '',
		region: '',
		subregion: '',
		sitecode: '',
		disease: '',
		species: ''
	});
	

	const UpdateStateOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			state: _e.target.selectedOption.value,
			region: '',
			subregion: '',
			sitecode: '',
			disease: '',
			species: '',
		});
	}
	const UpdateRegionOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			region: _e.target.selectedOption.value,
			subregion: '',
			sitecode: '',
			disease: '',
			species: '',
		});
	}

	const UpdateSubRegionOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			subregion: _e.target.selectedOption.value,
			sitecode: '',
			disease: '',
			species: '',
		});
	}
	const UpdateSiteCodeOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			sitecode: _e.target.selectedOption.value,
		});
	}
	const UpdateDiseaseOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			disease: _e.target.selectedOption.value,
		});
	}
	const UpdateSpeciesOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			species: _e.target.selectedOption.value,
		});
	}

	
	const DisplayChoicesPreviouslyMade = () => {
		const createLi = [];
		if( dataOptions.state ) {
			createLi.push(`State: ${dataOptions.state}`);
		}else{
			createLi.push(`State: All States`);
		}
		if( dataOptions.region ) {
			createLi.push(`Region: ${dataOptions.region}`);
		}else{
			createLi.push(`Region: All Regions`);
		}

		if( dataOptions.subregion ) {
			createLi.push(`Subregion: ${dataOptions.subregion}`);
		}else{
			createLi.push(`Subregion: All Subregions`);
		}

		if( dataOptions.sitecode ) {
			createLi.push(`Sitecode: ${dataOptions.sitecode}`);
		}else{
			createLi.push(`Sitecode: All Sitecodes`);
		}

		if( dataOptions.species ) {
			createLi.push(`Species: ${dataOptions.species}`);
		}else{
			createLi.push(`Species: All Species`);
		}

		if( dataOptions.disease ) {
			createLi.push(`Pathogen: ${dataOptions.disease}`);
		}else{
			createLi.push(`Pathogen: All Pathogens`);
		}
		
		
		return( 
			<ul>
				{createLi.map( (liItem, key) => { return <li key={key}>{liItem}</li>})}
			</ul>
		)
	}

	const StartDownloadCsv = () => {
		DownloadDataIntoCsv(dataOptions, iframeRef);
	}


	const GetAvailableSpecies = () => {
		//If we have everything, return the item as is.
		if( dataOptions.state && dataOptions.region && dataOptions.subregion ) {
			return graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].available_species.filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});
		}else if( dataOptions.state && dataOptions.region) {
			//Well, okay let's see if there's a region at least and concat items.
			let myRegionSpecies = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).forEach( (subregion, key) =>{
				myRegionSpecies=myRegionSpecies.concat(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][subregion].available_species);
			});

			return [...new Set(myRegionSpecies)].filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});
			/*[dataOptions.subregion].available_species.filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});*/

		}else if( dataOptions.state ) {
			///...okay well how about just s state then.
			let myStateSpecies = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state]).forEach( (regionName, key) =>{
				Object.keys(graphingOptions.controlOptions[dataOptions.state][regionName]).forEach( (subregion) => {
					myStateSpecies=myStateSpecies.concat(graphingOptions.controlOptions[dataOptions.state][regionName][subregion].available_species);
				});
			});
			return [...new Set(myStateSpecies)].filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});

		}

		let myAllSpecies = [];
		Object.keys(graphingOptions.controlOptions).forEach( (stateName) =>{
			Object.keys(graphingOptions.controlOptions[stateName]).forEach( (regionName) =>{
				Object.keys(graphingOptions.controlOptions[stateName][regionName]).forEach( (subregion) => {
					myAllSpecies=myAllSpecies.concat(graphingOptions.controlOptions[stateName][regionName][subregion].available_species);
				});
			});
		});
		
		return [...new Set(myAllSpecies)].filter((species)=>{
			return !(['','null'].includes(species.toLocaleLowerCase() ));
		});

	}

	const GetAvailableDiseases = () => {

		//If we have everything, return the item as is.
		if( dataOptions.state && dataOptions.region && dataOptions.subregion ) {
			return graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].available_diseases.filter((diseases)=>{
				return !(['','null'].includes(diseases.toLocaleLowerCase() ));
			});
		}else if( dataOptions.state && dataOptions.region) {
			//Well, okay let's see if there's a region at least and concat items.
			let myRegionDisease = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).forEach( (subregion, key) =>{
				myRegionDisease=myRegionDisease.concat(graphingOptions.controlOptions[dataOptions.state][dataOptions.region][subregion].available_diseases);
			});

			return [...new Set(myRegionDisease)].filter((diseases)=>{
				return !(['','null'].includes(diseases.toLocaleLowerCase() ));
			});
			/*[dataOptions.subregion].available_species.filter((species)=>{
				return !(['','null'].includes(species.toLocaleLowerCase() ));
			});*/

		}else if( dataOptions.state ) {
			///...okay well how about just s state then.
			let myStateDisease = [];
			Object.keys(graphingOptions.controlOptions[dataOptions.state]).forEach( (regionName, key) =>{
				Object.keys(graphingOptions.controlOptions[dataOptions.state][regionName]).forEach( (subregion) => {
					myStateDisease=myStateDisease.concat(graphingOptions.controlOptions[dataOptions.state][regionName][subregion].available_diseases);
				});
			});
			return [...new Set(myStateDisease)].filter((diseases)=>{
				return !(['','null'].includes(diseases.toLocaleLowerCase() ));
			});

		}

		let myAllDisease = [];
		Object.keys(graphingOptions.controlOptions).forEach( (stateName) =>{
			Object.keys(graphingOptions.controlOptions[stateName]).forEach( (regionName) =>{
				Object.keys(graphingOptions.controlOptions[stateName][regionName]).forEach( (subregion) => {
					myAllDisease=myAllDisease.concat(graphingOptions.controlOptions[stateName][regionName][subregion].available_diseases);
				});
			});
		});
		return [...new Set(myAllDisease)].filter((diseases)=>{
			return !(['','null'].includes(diseases.toLocaleLowerCase() ));
		});

	}

	useEffect( () =>{
		initGraphOptions();
	}, [initGraphOptions] );
	

	return (
		<CalciteBlock 
		heading="Download Data"
		summary="Download Data"
		collapsible={true}
		>
			<CalcitePanel>
			<CalciteStepper layout="vertical" scale="s" icon={true}>
				<CalciteStepperItem className="no-outline" 
				itemTitle="Location" itemSubtitle="Select the area you want to look at." 
				complete={dataOptions.state || null}>
					<CalciteLabel>
						State: 
						<CalciteSelect label="State" name="state" scale="m" onCalciteSelectChange={UpdateStateOption}>
							<CalciteOption value={''} label="- All States -" selected={!dataOptions.state}></CalciteOption>
							{Object.keys(graphingOptions.controlOptions).map( (stateName, key) =>{
								return (<CalciteOption key={key} value={stateName} selected={dataOptions.state === stateName}>{stateName}</CalciteOption>);
							})}
						</CalciteSelect>
					</CalciteLabel>
					<CalciteLabel disabled={!dataOptions.state || null} >
						Region: 
						<CalciteSelect label="Region" name="region" scale="m" onCalciteSelectChange={UpdateRegionOption}>
							<CalciteOption value={''} label="- All Regions -" selected={!dataOptions.region}></CalciteOption>
							{
								dataOptions.state 
								? Object.keys(graphingOptions.controlOptions[dataOptions.state]).map( (regionName, key) =>{
									return (<CalciteOption key={key} value={regionName} selected={dataOptions.region === regionName} label={regionName}></CalciteOption>);
								}) : null
							}	
						</CalciteSelect>
					</CalciteLabel>
					<CalciteLabel disabled={!dataOptions.state || !dataOptions.region || null} >
						Sub-region: 
						<CalciteSelect label="Sub-region" name="sub-region" scale="m" onCalciteSelectChange={UpdateSubRegionOption}>
							<CalciteOption value={''} label="- All Sub-regions -" selected={!dataOptions.subregion}></CalciteOption>
							{
								dataOptions.state && dataOptions.region
								? Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).map( (subregionName, key) =>{
									return (<CalciteOption key={key} value={subregionName} selected={dataOptions.subregion === subregionName} label={subregionName}></CalciteOption>);
								}) : null
							}	
						</CalciteSelect>
					</CalciteLabel>
					<CalciteLabel disabled={!dataOptions.state || !dataOptions.region || !dataOptions.subregion || null} >
						Sitecode: 
						<CalciteSelect label="Sitecode" name="sitecode" scale="m" onCalciteSelectChange={UpdateSiteCodeOption}>
							<CalciteOption value={''} label="- All Site-Codes -" selected={!dataOptions.sitecode}></CalciteOption>
							{
								dataOptions.state && dataOptions.region && dataOptions.subregion
								? graphingOptions.controlOptions[dataOptions.state][dataOptions.region][dataOptions.subregion].available_sitecodes.filter((sitecode)=>{
									return !(['','null'].includes(sitecode.toLocaleLowerCase() ));
								}).map( (sitecode, key) =>{
									return (<CalciteOption key={key} value={sitecode} selected={dataOptions.sitecode === sitecode} label={sitecode}></CalciteOption>);
								}) : null
							}	
						</CalciteSelect>
					</CalciteLabel>
				</CalciteStepperItem>
				<CalciteStepperItem 

					className="no-outline"
					disabled={null}
					complete={dataOptions.disease || dataOptions.species || null }
					itemTitle="Species / Pathogen" itemSubtitle="(Optional) Choose a species and / or pathogen">
{/* Species should filter disease drop down */}
					<CalciteLabel>
						Species: 
						<CalciteSelect label="Species" name="species" scale="m" onCalciteSelectChange={UpdateSpeciesOption}>
							<CalciteOption value={''} label="- All Species -" selected={!dataOptions.species}></CalciteOption>
							{
								GetAvailableSpecies()
								.map( (species, key) =>{
									return (<CalciteOption key={key} value={species} selected={dataOptions.species === species} label={species}></CalciteOption>);
								}) 
							}	
						</CalciteSelect>
					</CalciteLabel>
					<CalciteLabel>
						Pathogen: 
						<CalciteSelect label="Pathogen" name="disease" scale="m" onCalciteSelectChange={UpdateDiseaseOption}>
							<CalciteOption value={''} label="- All Pathogens -" selected={!dataOptions.disease}></CalciteOption>
							{
								GetAvailableDiseases()
								.map( (disease, key) =>{
									return (<CalciteOption key={key} value={disease} selected={dataOptions.disease === disease} label={disease}></CalciteOption>);
								})
							}	
						</CalciteSelect>
					</CalciteLabel>
				</CalciteStepperItem>
				<CalciteStepperItem 
					className="no-outline"
					disabled={null}
					itemTitle="Review" itemSubtitle="Confirm choices">
					{DisplayChoicesPreviouslyMade()}
					<CalciteButton  onClick={(_e) => {
						StartDownloadCsv();
					}} iconStart="file-csv"> Download CSV </CalciteButton>
				</CalciteStepperItem>
			</CalciteStepper>
			</CalcitePanel>
			<iframe title="download-data-block-csv-download" ref={iframeRef} style={{display:'none', width:'100%'}}></iframe>
		</CalciteBlock>
	);
}

const mapStateToProps = (state) => ({
	graphingOptions: state.graphingOptions
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	initGraphOptions: () => {dispatch(loadGraphingSelectOptions())},
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadDataBlock);
